module.exports = __webpack_public_path__ + "img/add-image20.8ae082cc.png";